import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';


export const sapBwCubeMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.sapBw.datasetType,
    displayName: stringResources.SapBW_DisplayText,
    supportLinkedServiceTypes: [adfModelTypeMap.sapBw.linkedServiceType],
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    disableTableName: true,
    icon: {
        className: 'svg-i-100x100-SapBW'
    },
    isFirstClass: true,
    category: ['Database'],
    copySourceControls: [],
    copySinkControls: []
};
